import React from 'react';
import { autobind } from 'core-decorators';
import Layout from '../components/Layout/LayoutIndex';
import { getHtmlTDK } from '../../../lib/utils/UtilsCommon';
import './AboutQlEdu.less';
import Modal from './dialog/index';
import FixedRightTools from '../components/fixed-right-tools';
import faqData from '../../../data/faqData';

interface IState {
	htmlTDK: {
		title: string;
		pageDescription: string;
		pageKeyword: string;
	};
	activeTab: number;
	showTeacherModal: boolean;
	showTeacherModalIndex: number;
	cultureContentHeight: number;
	expandedFaqIndex: number; // 当前展开的问题索引，默认0表示第一个展开
}

@autobind
class AboutQlEdu extends React.Component<any, IState> {
	private protectionContentRef: React.RefObject<HTMLDivElement> = React.createRef();
	constructor(props: any, context?: any) {
		super(props, context);

		const state: IState = {
			htmlTDK: {
				title: '兴趣岛公司介绍——名师更多，课程更全',
				pageDescription:
					'兴趣岛兴趣学堂-名师更多，课程更全。摄影、瑜伽等30门主流课程21门学员数量全国领先。',
				pageKeyword:
					'兴趣,兴趣岛,兴趣岛兴趣学堂,兴趣学堂,千聊兴趣岛,兴趣岛-名师更多，课程更全,兴趣岛兴趣学堂-名师更多，课程更全,千聊,知识付费,内容付费,千聊特训营,成人教育',
			},
			activeTab: 0, // 初始化为第一个标签
			showTeacherModal: false,
			showTeacherModalIndex: 0,
			cultureContentHeight: 0,
			expandedFaqIndex: 0, // 默认第一个问题展开
		};

		this.state = state;
	}

	public static async getInitialProps(context: any): Promise<any> {
		return {};
	}

	componentDidMount(): void {
		// 页面加载完成后的处理
		const element = this.protectionContentRef.current;
		if (element) {
			const width = element.offsetWidth;
			this.setState({ cultureContentHeight: width * 0.4055 });
		}

		const link1 = document.createElement('link');
		link1.rel = 'preload';
		link1.as = 'image';
		link1.href =
			'https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/43MADFA8-5Y2S-X6KA-1770878841602-KKRTQKEPSROM.png';
		document.head.appendChild(link1);

		const link2 = document.createElement('link');
		link2.rel = 'preload';
		link2.as = 'image';
		link2.href =
			'https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/MPDR8DMA-I5YZ-FSSJ-1770878849221-WRS2ACTBOPSK.png';
		document.head.appendChild(link2);

		const link3 = document.createElement('link');
		link3.rel = 'preload';
		link3.as = 'image';
		link3.href =
			'https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/69P2UJUZ-E128-SOKD-1770878836974-8NUGRLOHFXRQ.png';
		document.head.appendChild(link3);
	}

	// 新增方法：处理标签点击
	handleTabClick(tabName: number): void {
		this.setState({ activeTab: tabName });
	}
	// 新增方法：隐藏弹窗
	hideTeacherModal(): void {
		this.setState({ showTeacherModal: false });
	}

	// 新增方法：显示弹窗
	handleShowTeacherModal(index): void {
		this.setState({ showTeacherModal: true, showTeacherModalIndex: index });
	}

	handleFaqClick(index: number): void {
		this.setState((prevState) => ({
			// 如果点击的是当前展开的问题，则收起；否则展开点击的问题
			expandedFaqIndex: prevState.expandedFaqIndex === index ? -1 : index,
		}));
	}

	public render(): any {
		const {
			htmlTDK,
			activeTab,
			showTeacherModal,
			showTeacherModalIndex,
			cultureContentHeight,
			expandedFaqIndex,
		} = this.state;

		return (
			<Layout
				{...getHtmlTDK(htmlTDK)}
				bodyClass="about-company-page"
				region="about_company"
				activeTab="about"
			>
				<div className="about-company-wrapper">
					{/* 公司简介横幅图片 */}
					<div className="company-banner-section">
						<img
							src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021011/4JLD1BCP-4UTG-Q4QY-1770705260241-52WT7M7HW4MB.png"
							alt=""
						/>
						{/* 公司基本信息区域 */}
						<div className="company-info-section">
							<div className="info-container">
								<div className="company-intro-text">
									<p>
										兴趣岛是一家成立于2016年的文化服务科技公司，致力于为用户提供可信赖的兴趣学习产品与服务。截至目前，兴趣岛App注册用户已突破5000万。根据艾媒咨询认证，在手机摄影、中式瑜伽、武当太极、声乐唱歌等30门主流课程中21门学员数量超百万。
									</p>
									<p>
										公司始终以“连接极致专业与富有使命的名师，打造普惠、美好、个性化的兴趣学习平台，为人们构建起一所激发生命热爱的精神乐园”为使命，持续深耕兴趣学习领域十年。入选“中国产业科技百强企业”，连续五年被广州市科学技术局评为“广州市未来独角兽创新企业”，连续三年获认“广东省专精特新企业”。
									</p>
									<p>
										在推动文化传承与社会责任方面，兴趣岛于2024-2025年深度联合武当山举办线下太极传承活动，助力传统文化弘扬；2022年起连续五年举办手机摄影大赛，携手《中国摄影报》为乐龄群体提供展示兴趣与才华的舞台。兴趣岛的实践与成果备受权威媒体关注，多次获得人民日报、新华网、央视等主流媒体的采访和报道。
									</p>
								</div>
							</div>
						</div>
					</div>
					{/* 企业使命和愿景 */}
					<div className="mission-vision-section-wrap">
						<div className="mission-vision-section">
							<div>
								<div className="mission-item">
									<div className="section-title">企业使命</div>
									<div className="section-content">
										连接极致专业与富有使命的名师，打造普惠、美好、个性化的兴趣学习平台，为人们构建起一所激发生命热爱的精神乐园。
									</div>
								</div>
								<div className="mission-item-br"> </div>
								<div className="vision-item">
									<div className="section-title">企业愿景</div>
									<div className="section-content">
										成为服务3亿新成人专业、个性化和高性价比的数智化兴趣学习平台。
									</div>
								</div>
							</div>
						</div>
						<div className="mission-vision-section-wrap-img">
							<img
								src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021011/ZXVJFTV6-HCXL-YZ6K-1770707213969-Y19PVQ6KJFFR.png"
								alt=""
							/>
						</div>
					</div>

					<div className="boss-Introduction-section">
						<img
							src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/MVCQKQ8G-63FW-WKJ8-1770807301052-LW82T5J6RO3B.png"
							alt=""
						/>
					</div>

					{/* 企业文化区域 */}
					<div className="culture-section">
						<div className="culture-container">
							<div className="culture-header">
								<div className="section-title-wrapper">
									<div className="title-decoration">
										<div className="circle-left"></div>
										<div className="title-text">兴趣岛倡导好课良师益友理念</div>
										<div className="circle-right"></div>
									</div>
									<div className="subtitle-text">
										保障学员高质量学习体验，推动学员权益保障和行业标准化发展
									</div>
								</div>
								<div className="culture-tabs">
									<div
										className={`tab-item ${activeTab === 0 ? 'active' : ''}`}
										onClick={() => this.handleTabClick(0)}
									>
										学员保障
									</div>
									<div
										className={`tab-item ${activeTab === 1 ? 'active' : ''}`}
										onClick={() => this.handleTabClick(1)}
									>
										课程特色
									</div>
									<div
										className={`tab-item ${activeTab === 2 ? 'active' : ''}`}
										onClick={() => this.handleTabClick(2)}
									>
										服务保障
									</div>
									<div
										className={`tab-item ${activeTab === 3 ? 'active' : ''}`}
										onClick={() => this.handleTabClick(3)}
									>
										服务标准
									</div>
								</div>
							</div>
							{activeTab === 0 && (
								<div
									className="culture-content"
									ref={this.protectionContentRef}
									style={{ height: cultureContentHeight }}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/BM7O1APY-QJLJ-VR35-1770878845166-86IVRLCBJ9B2.png"
										alt=""
									/>
									<div className="protection-content">
										<div className="protection-list">
											<div className="protection-item">不名师，不开课</div>
											<div className="protection-item">不满意，可换课</div>
											<div className="protection-item">
												不放水，每课十道工
											</div>
											<div className="protection-item">
												不套路，如老友相处
											</div>
											<div className="protection-item">
												不走心，就换班主任
											</div>
											<div className="protection-item">
												不内卷，快乐陪伴温馨
											</div>
											<div className="protection-item">
												每品类必多名师，可比较选择
											</div>
											<div className="protection-item">
												每品类必全课程，想要的都有
											</div>
										</div>
									</div>
								</div>
							)}
							{activeTab === 1 && (
								<div
									className="culture-content"
									style={{ height: cultureContentHeight }}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/43MADFA8-5Y2S-X6KA-1770878841602-KKRTQKEPSROM.png"
										alt=""
									/>
									<div className="protection-content">
										<div className="protection-list">
											<div className="protection-item">
												入门正，名师授课学名门正宗
											</div>
											<div className="protection-item">
												学得快，专业工序磨课节奏明
											</div>
											<div className="protection-item">
												效果强，百里挑一得独家方法
											</div>
											<div className="protection-item">
												很上瘾，体系环环相扣有心流
											</div>
											<div className="protection-item">
												真价值，兴趣变能力改变生活
											</div>
											<div className="protection-item">
												交学友，志趣结交交流有温度
											</div>
										</div>
									</div>
								</div>
							)}
							{activeTab === 2 && (
								<div
									className="culture-content"
									style={{ height: cultureContentHeight }}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/MPDR8DMA-I5YZ-FSSJ-1770878849221-WRS2ACTBOPSK.png"
										alt=""
									/>
									<div className="protection-content">
										<div className="culture-list">
											<div className="protection-item">
												三师辅导：名师授课，助教点评和班主答疑，三师服务每个学员
											</div>
											<div className="protection-item">
												快速响应：当日作业当日点评，学员疑问24点前必回复，100%不留疑问
											</div>
											<div className="protection-item">
												温馨陪伴：打造有温度的学习氛围，营内营外陪伴常在
											</div>
											<div className="protection-item">
												服务保障：平台有监督，24小时内受理，48小时内完结
											</div>
										</div>
									</div>
								</div>
							)}
							{activeTab === 3 && (
								<div
									className="culture-content"
									style={{ height: cultureContentHeight }}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021211/69P2UJUZ-E128-SOKD-1770878836974-8NUGRLOHFXRQ.png"
										alt=""
									/>
									<div className="protection-content">
										<div className="protection-list">
											<div className="protection-item">
												不做任何围绕政治话题开展的项目及活动
											</div>
											<div className="protection-item">
												不做导向不良价值观的行为
											</div>
											<div className="protection-item">
												不做虚假广告夸大效果以误导用户
											</div>
											<div className="protection-item">
												不做让用户借贷购买产品的行为
											</div>
											<div className="protection-item">
												不做有关医疗治疗的产品服务
											</div>
											<div className="protection-item">
												不做泄露损害用户隐私的行为
											</div>
											<div className="protection-item">
												不做背离企业使命的短期逐利行为
											</div>
											<div className="protection-item">
												不做违背自身信念的内容和品类
											</div>
											<div className="protection-item">
												不做客单过高、服务周期过长的产品
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>

					{/* 发展历程区域 */}
					<div className="development-section">
						<img
							src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/SEMGDR1T-EXD3-C53Q-1770777523012-2UWJNRWIOC7K.png"
							alt="兴趣岛发展历程"
							className="development-image"
						/>
					</div>

					{/* 名师标准区域 */}
					<div className="teacher-standard-section">
						<div className="standard-container">
							<div className="standard-header">
								<div className="section-title-wrapper">
									<div className="title-decoration">
										<div className="circle-left"></div>
										<div className="title-text">兴趣岛的名师有标准</div>
										<div className="circle-right"></div>
									</div>
									<div className="subtitle-text">
										不名师不开课，每一种热爱的背后，都有名师陪伴
									</div>
								</div>
								<div className="standard-criteria">
									<div className="criteria-item">① 从业时长10年以上</div>
									<div className="criteria-item">② 具备行业顶尖资质</div>
									<div className="criteria-item">③ 有强效果口碑案例1000+</div>
									<div className="criteria-item">
										④ 有多名持续跟随学习5年以上的用户
									</div>
									<div className="criteria-item">
										⑤ 有普世教育和尊爱学员的情怀
									</div>
								</div>
							</div>
							<div className="teachers-gallery">
								<div
									className="gallery-item"
									style={{ marginTop: '12px' }}
									onClick={() => {
										this.handleShowTeacherModal(0);
									}}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/5NSEZ8LX-FRKM-QHGC-1770807767961-M4QFC9WZMKAT.png"
										alt="名师1"
									/>
								</div>
								<div
									className="gallery-item"
									onClick={() => {
										this.handleShowTeacherModal(1);
									}}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/1QG73RX8-MWIT-26IX-1770807772168-QC9GZE7F3IT8.png"
										alt="名师2"
									/>
								</div>
								<div
									className="gallery-item"
									style={{ marginTop: '12px' }}
									onClick={() => {
										this.handleShowTeacherModal(2);
									}}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/2ZK1ZBCK-3XHM-TVJG-1770807776834-LXEKQNKJ4XN8.png"
										alt="名师3"
									/>
								</div>
								<div
									className="gallery-item"
									style={{ marginTop: '12px' }}
									onClick={() => {
										this.handleShowTeacherModal(3);
									}}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/JJDL34C7-XGZP-8KLH-1770807783552-JA9AJI413W5F.png"
										alt="名师4"
									/>
								</div>
								<div
									className="gallery-item"
									style={{ marginTop: '12px' }}
									onClick={() => {
										this.handleShowTeacherModal(4);
									}}
								>
									<img
										src="https://media.qianliaowang.com/xqd/tools/activity/image/2026021111/VUN4R37Q-33WR-OYDJ-1770807786425-8K4A1JWZ5CUD.png"
										alt="名师5"
									/>
								</div>
							</div>
						</div>
					</div>

					{/* 常见问题解答区域 */}
					<div className="faq-section">
						<div className="faq-container">
							<div className="faq-header">
								<div className="circle-left"></div>
								<div className="faq-title">兴趣岛常见问题解答</div>
								<div className="circle-right"></div>
							</div>
							<div className="faq-list">
								{faqData.map((item, index) => (
									<div
										key={item.question}
										className={`faq-item ${
											expandedFaqIndex === index ? 'faq-item-expanded' : ''
										}`}
										onClick={() => this.handleFaqClick(index)}
									>
										<div className="faq-question-row">
											<div className="faq-expand-icon">
												<img
													src={
														expandedFaqIndex === index
															? 'https://media.qianliaowang.com/xqd/tools/activity/image/2026030311/VC7BDQQ6-NMNM-7VDQ-1772520359413-NTO15BDJVBT2.png'
															: 'https://media.qianliaowang.com/xqd/tools/activity/image/2026030311/PRZ39NLF-W5J1-SM8Y-1772520369903-WE2GNYPCMC61.png'
													}
													alt=""
												/>
											</div>
											<div className="faq-question">{item.question}</div>
										</div>
										<div
											style={{
												height: expandedFaqIndex === index ? 'auto' : '0',
												overflow: 'hidden',
											}}
										>
											{item.answer.map((item2, index) => (
												<div key={index + item2} className="faq-answer">
													{item2}
												</div>
											))}
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
				<FixedRightTools />
				<Modal
					showTeacherModal={showTeacherModal}
					index={showTeacherModalIndex}
					onCancel={this.hideTeacherModal}
				></Modal>
			</Layout>
		);
	}
}
export default AboutQlEdu;
